/*

@@author        j0Shi
@@date          2019.08.21
@@desc          A simple loading logic for components that sets a loading state
@@usedby        Object

*/

const LoadingLogic = {
  props: {
    // whether or not to watch route for load enabling and disabling
    // usually rout components should enable / disable on route, others not
    llMixin_watchRoute: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // boolean marker for whether the component is loading
      llMixin_componentIsLoading: false,
      // component property to watch for loadingState
      // this is null by default but should be altered by the component
      // the property has to be reactive to trigger update
      llMixin_componentLoadingProperty: null,
      // boolean marker indicating that the module got prefetched
      llMixin_wasPrefetched: false,
      // watcher for the component loading property
      llMixin_watcher: null,
    };
  },
  watch: {
    $route: 'llMixin_updateRouteLoading',
  },
  methods: {
    // is triggered from route watch and checks whether or not to enable loading on route switch
    llMixin_updateRouteLoading(from, to) {
      if (this.llMixin_watchRoute) this.llMixin_enableLoading(from, to);
    },
    // toggle to enable / disable loading
    llMixin_updateLoading(value, oldValue, delay = true) {
      if (value) this.llMixin_enableLoading();
      else this.llMixin_disableLoading(delay);
    },
    // enable loading when component loads
    llMixin_enableLoading({ path: fromPath = '' } = {}, { path: toPath = '' } = {}) {
      if (fromPath !== toPath || (fromPath === '' && toPath === '')) this.llMixin_componentIsLoading = true;
    },
    // try to disabled loading
    llMixin_disableLoading(delay = true) {
      if (delay) {
        setTimeout(() => { this.llMixin_componentIsLoading = false; }, 500);
      } else {
        this.llMixin_componentIsLoading = false;
      }
    },
    llMixin_addComponentLoadingIndicator(prop) {
      this.llMixin_componentLoadingProperty = prop;
      this.llMixin_watcher = this.$watch(`${prop}`, this.llMixin_updateLoading);
      this.llMixin_updateLoading(this[this.llMixin_componentLoadingProperty], this[this.llMixin_componentLoadingProperty], false);
    },
  },
  serverPrefetch() {
    // default for ssr is no loading animation
    this.llMixin_componentIsLoading = false;
    // write ssr indicator in store, default is false
    return Promise.resolve();
  },
  // destroy our watcher
  beforeDestroy() {
    if (this.llMixin_watcher !== null) this.llMixin_watcher();
  },
};

export default LoadingLogic;
